import useSWR from "swr";
import { SWR_CONFIG_FOR_STATIC_DATA } from "../constants/swr/swrConfigForStaticData";
import { isNullOrUndefined } from "../helpers/common/isNullOrUndifined";
import generateApiUri from "../libraries/utils/generateApiUri";
import useApiFetcher from "./useApiFetcher";

/**
 * @param {object} param0
 * @param {string} [param0.schoolId]
 * @param {string} [param0.environmentId]
 * @param {string} [param0.yearId]
 * @returns {string[]}
 */
export function useSchoolLevels({ schoolId, environmentId, yearId }) {
  const apiFetcher = useApiFetcher();

  const { data: response } = useSWR(
    !isNullOrUndefined(schoolId) &&
      schoolId !== "" &&
      !isNullOrUndefined(environmentId) &&
      environmentId !== "" &&
      !isNullOrUndefined(yearId) &&
      yearId !== ""
      ? generateApiUri({
          id: "@places.view",
          parameters: {
            placeId: schoolId,
          },
          query: {
            year_id: [yearId],
            fields: ["place.setting_by_year"],
          },
        })
      : null,
    apiFetcher,
    SWR_CONFIG_FOR_STATIC_DATA,
  );

  return response?.data?.setting_by_year?.levels ?? [];
}
